import React, {Fragment} from "react"

const WidgetForm = () => {

    const handleSubmit = (e) => {
        e.preventDefault();
    }
    return (
        <Fragment>
            <form action="#" onSubmit={handleSubmit}>
                <input type="text" placeholder="Ingresa tu Nombre"/>
                <input type="email" placeholder="Correo Electrónico"/>
                <textarea name="message" placeholder="Escribe tu Mensaje" defaultValue={""}/>
                <button className="widget-btn mt-20">Contáctanos</button>
            </form>
        </Fragment>
    )
}

export default WidgetForm